function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const claimScheduleService = {
  get(claimGroupId, id) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/claim_schedules/").concat(id), request.get);
  },
  sendIntroductionMail(scheduleId) {
    return fetch("/api/claim_schedules/".concat(scheduleId, "/claim_schedule_kickoff_mailer"), _objectSpread({}, request.post));
  },
  sendIcsEventMail(scheduleId) {
    return fetch("/api/claim_schedules/".concat(scheduleId, "/claim_schedule_ics_mailer"), _objectSpread({}, request.post));
  },
  update(claimGroupId, claim_schedule) {
    return fetch("/api/claim_groups/".concat(claimGroupId, "/claim_schedules/").concat(claim_schedule.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        claim_schedule
      })
    }));
  },
  updateEmailManagerIncluded(claimGroupId, claim_schedule, manager_included, is_cost_email) {
    if (is_cost_email) {
      claim_schedule.exclude_manager_from_cost_template_email = manager_included;
    } else {
      claim_schedule.exclude_manager_from_introduction_email = manager_included;
    }
    return this.update(claimGroupId, claim_schedule);
  },
  sendClientCostMail(scheduleId) {
    return fetch("/api/claim_schedules/".concat(scheduleId, "/client_cost_template_mailer"), _objectSpread({}, request.post));
  }
};
export default claimScheduleService;